<div class="not-found-wrapper">
  <h1>Page not found</h1>
  <h3>We're sorry, but Torch was unable to locate the page requested. Instead, enjoy this nice little {{chartType}}!</h3>
  <h2 class="chart-title" *ngIf="chartTitle != null">{{chartTitle}}</h2>
  <div class="chart-wrapper" id="mainChart"></div>
  <button mat-raised-button (click)="goToDashboard()" color="primary">Go to Dashboard</button>
</div>
